// extracted by mini-css-extract-plugin
export default {"arrow":"UpArrow_arrow__34vTZ"};